import React, {
	Component
} from 'react';
import Content from './components/Content';
import {
	CommunityWrapper,
} from './style';

class Audition extends Component {
	render() {
		return (
			<CommunityWrapper>
                <Content location={this.props.location} />
            </CommunityWrapper>
		)
	}
}

export default Audition